// extracted by mini-css-extract-plugin
export default {"spinner":"loading-spinner_spinner__-TBqq","spin":"loading-spinner_spin__jpf40"};